// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"App_sidebarContainer__2niHZ","contentContainer":"App_contentContainer__1_Czk","pageContainer":"App_pageContainer__3kYYz"};